import { make } from 'vuex-pathify';
import state from './state';

export default {
    ...make.actions(state),

    getEditableUid({ getters, commit }) {
        const uid = getters.nextEditableUid;

        commit('INCREMENT_NEXT_EDITABLE_UID');

        return uid;
    },
};
